import { useState } from 'react';
import { Link } from 'react-router-dom';
import { neighborhoodsByCity } from '../data/neighborhoodsData';
import { cities } from '../data/citiesData';
import { formatILS, formatPercent } from '../utils/format';

export default function Neighborhoods() {
  const [selectedCity, setSelectedCity] = useState('tel-aviv');
  const neighborhoods = neighborhoodsByCity[selectedCity] || [];
  const cityObj = cities.find(c => c.id === selectedCity);

  return (
    <div className="page-content">
      <div className="container">
        <span className="gold-tag">Analyse fine</span>
        <h1>Prix par quartier</h1>
        <p style={{ fontSize: '1.05rem', marginBottom: '2.5rem' }}>
          Données de prix au m² et rendements locatifs par quartier, pour les principales villes d'Israël.
        </p>

        {/* Sélecteur de ville */}
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '2.5rem' }}>
          {Object.keys(neighborhoodsByCity).map(cityId => {
            const city = cities.find(c => c.id === cityId);
            const active = selectedCity === cityId;
            return (
              <button key={cityId} onClick={() => setSelectedCity(cityId)} style={{
                padding: '0.6rem 1.25rem', borderRadius: 'var(--radius-sm)',
                border: `1.5px solid ${active ? 'var(--color-primary)' : 'var(--color-border)'}`,
                cursor: 'pointer', fontSize: '0.875rem', fontWeight: 600,
                fontFamily: 'var(--font-body)',
                background: active ? 'var(--color-primary)' : 'var(--color-bg-white)',
                color: active ? '#fafaf8' : 'var(--color-text-muted)', transition: 'all 0.2s',
              }}>
                {city?.name || cityId}
              </button>
            );
          })}
        </div>

        {cityObj && (
          <div style={{ background: 'var(--color-primary)', borderRadius: 'var(--radius-lg)', padding: '1.5rem 2rem', marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <h2 style={{ color: '#fafaf8', margin: 0, marginBottom: '0.25rem' }}>{cityObj.name}</h2>
              <p style={{ color: 'rgba(250,250,248,0.7)', margin: 0, fontSize: '0.9rem' }}>Prix moyen : {formatILS(cityObj.averagePricePerSqm)}/m² — {neighborhoods.length} quartiers analysés</p>
            </div>
            <Link to={`/villes/${cityObj.slug}`} className="btn btn-accent btn-sm">Voir la fiche ville complète</Link>
          </div>
        )}

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Quartier</th>
                <th>Prix moy./m²</th>
                <th>Rendement brut</th>
                <th>Profil</th>
                <th>Demande locative</th>
              </tr>
            </thead>
            <tbody>
              {neighborhoods.map((n, i) => (
                <tr key={i}>
                  <td><strong style={{ fontFamily: 'var(--font-display)', color: 'var(--color-primary)' }}>{n.name}</strong></td>
                  <td><strong>{formatILS(n.avgPricePerSqm)}</strong></td>
                  <td>
                    <span style={{ fontWeight: 700, color: n.avgYield >= 4 ? 'var(--color-success)' : 'var(--color-primary)' }}>
                      {formatPercent(n.avgYield)}
                    </span>
                  </td>
                  <td><span style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)' }}>{n.profile}</span></td>
                  <td>
                    <span className={`badge ${n.demand === 'très élevée' ? 'badge-success' : n.demand === 'élevée' ? 'badge-blue' : n.demand === 'moyenne' ? 'badge-neutral' : 'badge-warning'}`}>
                      {n.demand}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="insight-box" style={{ marginTop: '1.5rem' }}>
          Données indicatives 2024–2025 issues de l'observation du marché. Les prix peuvent varier significativement selon la rue, l'étage, l'état du bien et les conditions de marché au moment de la transaction.
        </div>
      </div>
    </div>
  );
}
